import Navigation from './Navigation';
import ImpersonationBanner from './admin/ImpersonationBanner';

const AppLayout = ({ children }) => {
  return (
    <>
      <ImpersonationBanner />
      {children}
      <Navigation />
    </>
  );
};

export default AppLayout;
